module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NO-03be1bd6abd8f634998d1da83acf26bd.png";